exports.default = {
  'title': '資產',
  'files_count': '{count} 個檔案',
  'folder_unit': '個資料夾',
  'all_assets': '全部資產',
  'folder': '資料夾',
  'default_space': '預設空間',
  'new_folder': '新建資料夾',
  'create_folder_hint': '整理你的資產',
  'folder_actions': '資料夾操作',
  'add_content': '新增內容',
  'upload_file': '上傳檔案',
  'upload_image_video': '上傳圖片/影片',
  'unsupported_upload_type': '「{name}」不是支援的圖片或影片格式，已略過',
  'upload_to': '上傳至',
  'selected_folder': '選擇位置',
  'upload_folder_search': '搜尋資料夾',
  'no_folder_match': '沒有符合的資料夾',
  'choose_upload_folder': '請選擇上傳資料夾',
  'uploading': '上傳中',
  'upload_waiting': '等待上傳',
  'upload_complete': '上傳完成',
  'upload_failed': '上傳失敗',
  'upload_success': '上傳成功',
  'upload_partial': '{count} 個檔案上傳失敗',
  'batch_operation': '批次操作',
  'exit_batch': '退出批次操作',
  'selected_assets': '已選擇資產',
  'batch_limit': '單次最多選擇 {count} 個資產',
  'batch_download': '批次下載',
  'batch_download_success': '已開始下載 {count} 個檔案',
  'batch_download_partial': '已開始下載 {success} 個檔案，{failed} 個檔案失敗',
  'download_started': '已開始下載',
  'download': '下載',
  'preview': '預覽',
  'preview_unavailable': '此檔案暫不支援線上預覽',
  'loading_preview': '正在準備預覽',
  'more_actions': '更多操作',
  'rename': '重新命名',
  'delete': '刪除',
  'move': '移動',
  'refresh': '重新整理',
  'loading_more': '正在載入更多...',
  'search': '搜尋',
  'keyword_placeholder': '關鍵字搜尋',
  'type_filter': '類型篩選',
  'type_all': '全部類型',
  'type_image': '圖片',
  'type_video': '影片',
  'type_audio': '音訊',
  'type_other': '其他',
  'date_filter': '日期篩選',
  'filter_date': '篩選日期',
  'filter_date_hint': '按建立時間篩選資產',
  'date_all': '全部時間',
  'date_today': '今天',
  'date_recent_5': '最近 5 天',
  'date_recent_15': '最近 15 天',
  'date_recent_30': '最近 30 天',
  'custom_date': '自訂範圍',
  'start_date': '開始日期',
  'end_date': '結束日期',
  'reset': '重設',
  'apply': '套用',
  'sort_by_update': '按更新時間排序',
  'newest_first': '最近更新',
  'oldest_first': '最早更新',
  'no_assets': '這裡還沒有資產',
  'no_filter_results': '沒有符合的資產',
  'try_other_filters': '請調整篩選條件後重試',
  'upload_to_start': '上傳檔案後，它們會出現在這裡',
  'folder_name': '資料夾名稱',
  'folder_name_placeholder': '請輸入資料夾名稱',
  'folder_name_required': '請輸入資料夾名稱',
  'folder_unavailable': '此資料夾不存在或已被刪除',
  'rename_folder': '重新命名資料夾',
  'delete_folder': '刪除資料夾',
  'confirm_delete_folder': '確定刪除資料夾「{name}」嗎？',
  'folder_not_empty': '此資料夾包含 {count} 個檔案，請選擇處理方式',
  'delete_folder_files': '刪除檔案後刪除資料夾',
  'move_folder_files': '移動檔案後刪除資料夾',
  'confirm_delete': '確認刪除',
  'move_assets': '移動資產',
  'move_assets_count': '將 {count} 個資產移動到：',
  'target_folder': '選擇目標資料夾',
  'rename_file': '重新命名檔案',
  'file_name': '檔案名稱',
  'file_name_required': '請輸入檔案名稱',
  'confirm_delete_asset': '確定刪除「{name}」嗎？',
  'confirm_delete_selected': '確定刪除選取的 {count} 個資產嗎？',
  'file_too_large': '「{name}」超過 50 MB，已略過',
  'image_file_too_large': '圖片「{name}」超過 20 MB，已略過',
  'operation_success': '操作成功',
  'operation_failed': '操作失敗，請稍後重試',
  'load_failed': '資產載入失敗，請稍後重試',
  'total_items': '共 {count} 個檔案',
  'visibility': '可見範圍',
  'visibility_private': '私有',
  'visibility_team': '團隊共享',
  'change_visibility_confirm': '確定將可見範圍改為「{visibility}」嗎？'
}
